import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = '';

interface ChatbotQueryRequest {
    question: string;
}

interface ChatbotQueryResponse {
    statusCode: number;
    success: boolean;
    message: string;
    data: {
        answer: string;
    };
}

export const chatbotApi = createApi({
    reducerPath: 'chatbotApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.NEXT_PUBLIC_API_URL}${BASE_URL}`,
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as any).auth.token || (typeof window !== 'undefined' ? localStorage.getItem('token') : null);
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        queryChatbot: builder.mutation<ChatbotQueryResponse, ChatbotQueryRequest>({
            query: (body) => ({
                url: '/chatbot/query',
                method: 'POST',
                body,
            }),
        }),
    }),
});

export const { useQueryChatbotMutation } = chatbotApi;
